import { render, staticRenderFns } from "./emojipicker.vue?vue&type=template&id=1cd1a04e&scoped=true&"
import script from "./emojipicker.vue?vue&type=script&lang=js&"
export * from "./emojipicker.vue?vue&type=script&lang=js&"
import style0 from "./emojipicker.vue?vue&type=style&index=0&id=1cd1a04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1a04e",
  null
  
)

export default component.exports